import DeviceTypeConflict from "@/modules/dis/service/inspection/DeviceTypeConflict";

const height = {
    header: 46,
    unit  : 32
}

const filterUnit = function (criteria, unit) {
    // "Typ-Konflikte" (HCIT-943) shows the conflicts whatever their state: they arise with the upload, so the
    // inspections are usually closed
    if (criteria.conflict) {
        if (!DeviceTypeConflict.unitHasConflict(unit)) {
            return false;
        }
    } else {
        if (!criteria.closed && unit.done) {
            return false;
        }

        if (!criteria.created && !unit.technicianId) {
            return false;
        }

        if (!criteria.assigned && (unit.technicianId && !unit.done)) {
            return false;
        }
    }

    if (criteria.unit) {
        const upperCaseText = criteria.unit.toUpperCase();
        if (!unit.elevatorNo) {
            return false;
        }

        if (!unit.elevatorNo.toUpperCase ().includes(upperCaseText)) {
            return false;
        }
    }

    return true;
}

export default {
    /**
     * Filters locations based on the given criteria and additional optional parameters.
     *
     * @param {Object} criteria - Criteria object containing filter conditions such as location, order, and zip range.
     * @param {Array} locations - Array of location objects to be filtered.
     * @param {Object} dispatcher - Dispatcher object to match technician ID.
     * @param {boolean} collapse - Flag to set the `expanded` property of locations.
     * @param {boolean} dispatchOn - Flag to filter units based on the presence of an order.
     * @return {Array|boolean} Returns the filtered array of locations if valid; otherwise, returns false.
     */
    filter (criteria, locations, dispatcher, collapse, dispatchOn) {
        if (!locations) {
            return false;
        }

        return locations.filter (location => {
            if (collapse) {
                location.expanded = false;
            }

            if (criteria.location) {
                if (!location.search.location.includes (criteria.location.toUpperCase())) {
                    return false;
                }
            }

            if (criteria.order) {
                if (!location.search.order.includes (criteria.order.toUpperCase())) {
                    return false;
                }
            }

            if (criteria.zip.from) {
                if (location.zip && ("" + location.zip <= ""+ criteria.zip.from)) {
                    return false;
                }
            }

            if (criteria.zip.to) {
                if (location.zip && (""+ location.zip >= "" + criteria.zip.to)) {
                    return false;
                }
            }

            const matchingUnits = location.units.filter (unit => {
                if (dispatchOn && (!unit.order || !unit.order.id)) {
                    return false;
                }

                if (!dispatcher || !criteria.user) {
                    return filterUnit(criteria, unit);
                } else if (dispatcher.id === unit.technicianId) {
                    return filterUnit(criteria, unit);
                } else {
                    return false;
                }
            });

            location.filteredUnits = matchingUnits;
            return matchingUnits.length > 0;
        });
    },

    /**
     * Groups the units by their location details, creating location headers and associating units with them.
     *
     * @param {Array} allUnits - An array of units, where each unit contains location details and contact information.
     * @return {Array} An array of grouped locations, where each location contains its associated unit information.
     */
    groupByLocation (allUnits) {
        let zip = "";
        let city = "";
        let street = "";
        let contact = "";
        let locations = [];
        let header = null;

        allUnits.forEach(unit => {
            const location = unit.location;

            const locZip    = location.zip ? location.zip.toLocaleUpperCase().trim() : "";
            const locCity   = location.city ? location.city.toLocaleUpperCase().trim() : "";
            const locStreet = location.street ? location.street.toLocaleUpperCase().trim() : "";

            if (   zip     !== locZip
                || city    !== locCity
                || street  !== locStreet
                || (contact ? contact : "-") !== (location.contact ? location.contact : "-")
            ) {
                const searchLocation =
                     (unit.location.zip     ? unit.location.zip.toUpperCase     () : "") + ";"
                    +(unit.location.city    ? unit.location.city.toUpperCase    () : "") + ";"
                    +(unit.location.street  ? unit.location.street.toUpperCase  () : "") + ";"
                    +(unit.location.contact ? unit.location.contact.toUpperCase () : "") + ";"
                ;

                header = {
                    row: -unit.row,
                    id: -unit.id,
                    header: true,
                    expanded: false,
                    zip: unit.zip,
                    city: unit.city,
                    street: unit.location.street,
                    units: [],
                    contact: location.contact,
                    filteredUnits: [],
                    assignedUnits: [],
 //                   order: null,
                    lastInGroup: false,
                    size: height.header,
                    search: {
                        location: searchLocation,
                        order   : ""
                    },
                    orderList: []
                };

                locations.push(header);

                zip = locZip;
                city = locCity;
                street = locStreet;
                contact = unit.location.contact;
            }

            unit.size = height.unit;
            unit.number  = unit.location["streetNo"];
            unit.headerId = header.id;
            header.units.push(unit);

            if (unit.order && unit.order) {
                header.order = unit.order;
                if (!header.orderList.find (o => unit.order && o.id === unit.order.id)) {
                    if (unit.order && unit.order.id) {
                        header.orderList.push (unit.order);
                        header.search.order += (unit.order.no.toUpperCase() + ";" + unit.order.customer.toUpperCase() + ";");
                    }
                }
            }

            if (unit.contact && unit.contact.onSite) {
                header.contacts = unit.contact.onSite;
            }

            header.filteredUnits.push(unit)
        });

        locations.forEach(location => {
            if (location.units) {
                location.units.sort((a, b) => {
                    const l = a && a.number ? a.number : ' ';
                    const r = b && b.number ? b.number : ' ';
                    const compare = l.localeCompare(r);
                    if (compare !== 0) {
                        return compare;
                    }
                    if (a.elevatorNo && b.elevatorNo) {
                        return a.elevatorNo.localeCompare(b.elevatorNo);
                    }
                    return 0;
                });
            }
        })

        return locations;
    },

    refresh (assignment, assignments) {
        const index = assignments.findIndex(a => a.id === assignment.id);
        if (index >= 0) {
            assignments[index] = assignment;
        }


   //     assignments.unshift(assignment);
        return assignment.unit;
    },

    /**
     * Expands all units with a header property and their associated filteredUnits.
     *
     * @param {Array} units - An array of unit objects to be expanded. Each object may contain
     *                        properties like `header`, `expanded`, `filteredUnits`, and others.
     *
     * @return {Array|undefined} An array of expanded units including all filtered units of those
     *                           with a header, or undefined if no units are provided.
     */
    expandAll (units) {
        if (!units) {
            return;
        }

        const expandedUnits = [];
        units.forEach(item => {
            if (item.header) {
                item.expanded = true;
                expandedUnits.push(item);
                item.filteredUnits.forEach(u => expandedUnits.push(u));
                if (item.filteredUnits.length > 0) {
                    item.filteredUnits[item.filteredUnits.length-1].lastInGroup = true;
                }
            }
        });

        return expandedUnits;
    },

    /**
     * Collapses all units by setting their `expanded` property to `false` if they have a `header`.
     * Additionally, sets the `lastInGroup` property of every unit to `false`.
     *
     * @param {Array} units - The array of unit objects to be modified. Each object may contain `header` and `expanded` properties.
     */
    collapseAll (units) {
        if (!units) {
            return;
        }

        units.forEach(item => {
            item.lastInGroup = false;
            if (item.header) {
                item.expanded = false;
            }
        });
    },

    /**
     * Expands the specified location within the given array of units, inserting its filtered units into the array
     * and marking the last unit in the group as the last in its group if applicable.
     *
     * @param {Object} location - The location object to match and expand. Contains properties such as zip, city, street, and contact.
     * @param {Array} units - The array of unit objects that may contain the location to expand. Each unit may include a `header`, `filteredUnits`, and other properties.
     */
    expand (location, units) {
        const index = units.findIndex(item => {
                return item.header
                    && (item.zip ? item.zip : "") === (location.zip ? location.zip : "")
                    && (item.city ? item.city : "") === (location.city ? location.city : "")
                    && (item.street ? item.street : "") === (location.street ? location.street : "")
                    && (item.contact ? item.contact : "") === (location.contact ? location.contact : "")
                    && this.sameOrder(item, location)

            }
        );

        if (index < 0) {
            return;
        }

        const header = units [index];
        if (header.expanded) {
            units.splice (index+1, 0, ...header.filteredUnits)
            if (header.filteredUnits.length > 0) {
                header.filteredUnits[header.filteredUnits.length-1].lastInGroup = true;
            }

            header.expanded = true;
        }
    },

    /**
     * Collapses a group of units in the provided list based on the given location match.
     *
     * @param {Object} location - The location object containing details to find the matching group.
     * @param {Array}  units - An array of unit objects, where some may represent grouped headers and others detailed units.
     */
    collapse (location, units) {
        const index = units.findIndex(item =>
            item.header
            && item.zip     === location.zip
            && item.city    === location.city
            && item.street  === location.street
            && item.contact === location.contact
            && (item.order ? item.order.id : "") === (location.order ? location.order.id : "")
        );

        if (index < 0) {
            return;
        }

        const header =units [index];
        if (!header.expanded) {
            units.splice (index+1, header.filteredUnits.length)
            header.expanded = false;
        }
    },


    sameOrder (item, unit) {
        return (item.order ? "" + item.order.id : "") === (unit.order ? "" + unit.order.id : "")
    },
}
